/*
 * Módulo vazio de propósito: é o guard do incidente de 2026-07-28, portado do webpack para o Vite.
 *
 * O CRA tinha `resolve.fallback = { path: false }`, então dependência que fizesse `require("path")`
 * recebia um módulo vazio em vez de quebrar. Sem isso, `mime-types.lookup()` chama
 * `require("path").extname`, o `extname` chega `undefined`, o `AttachFileButton` estoura no render e
 * a árvore React inteira cai — o widget sumiu para todo apostador por ~1h20, com 421 testes verdes,
 * typecheck limpo e build OK, porque os três rodam em Node e nenhum é o navegador.
 *
 * O Vite não tem `resolve.fallback`. O equivalente é um `resolve.alias` de `path` para este arquivo,
 * e o alias precisa apontar para um módulo que existe e não exporta nada: apelidar para um caminho
 * inexistente daria erro de build, e não o objeto vazio em runtime que o webpack entregava.
 *
 * Não transforme isto num polyfill de `path`. O objetivo é justamente que `path.extname` seja
 * `undefined`, como era no bundle do CRA. Quem depende de `path` no navegador está errado, e quem
 * resolve o problema de verdade é o `src/utils/fileTypes.ts`, com o mapa puro `types[ext]`. A
 * regressão está coberta em `src/utils/fileTypesBrowser.test.ts`.
 */

/** Reproduz o `{}` que o webpack entregava com `fallback: { path: false }`. */
const stubVazio = {};

/*
 * O `import/no-unused-modules` acusa aqui e está enganado: nada em `src/` importa este módulo de
 * propósito. Quem o consome é o `resolve.alias` do vite.config.ts, que redireciona todo
 * `require("path")` do grafo, inclusive de dependência transitiva. Apagar o export apaga o guard.
 */
// eslint-disable-next-line import/no-unused-modules
export default stubVazio;
